// 客户上下文 API hook（域内类型定义）
import { useQuery } from '@tanstack/react-query'
import { api } from '@/shared/api/client'

// 域内类型
export interface CustomerContextData {
  context_text: string
  company_id: number
  platform: string
  platform_user_id: string
}

// 解析后的字段
export interface ContextField {
  label: string
  value: string
}

/**
 * 将 context_text 按 | 分隔解析为键值对
 * 例: "客户已验证 | CPF: 820.701.640-04 | 姓名: Luis" → [{label:'', value:'客户已验证'}, {label:'CPF', value:'820.701.640-04'}, ...]
 */
export function parseContextText(text: string): ContextField[] {
  if (!text) return []
  return text
    .split('|')
    .map((segment) => {
      const trimmed = segment.trim()
      if (!trimmed) return null
      const colonIdx = trimmed.indexOf(':')
      if (colonIdx === -1) {
        return { label: '', value: trimmed }
      }
      return {
        label: trimmed.slice(0, colonIdx).trim(),
        value: trimmed.slice(colonIdx + 1).trim(),
      }
    })
    .filter((f): f is ContextField => f !== null && f.value !== '')
}

// 查询键
export const customerContextKeys = {
  all: ['customerContext'] as const,
  detail: (platform: string, platformUserId: string) =>
    [...customerContextKeys.all, platform, platformUserId] as const,
}

// 查询 hook — 手动刷新，不轮询
export const useCustomerContext = (
  platform: string,
  platformUserId: string,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: customerContextKeys.detail(platform, platformUserId),
    queryFn: async () => {
      return api.get<CustomerContextData>('/customer-context', {
        params: { platform, platform_user_id: platformUserId },
      })
    },
    enabled,
    staleTime: Infinity,
  })
}
